import localeNl from '@angular/common/locales/nl';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import { RetailSamenRekeningOpenenModule } from './retail-samen-rekening-openen.module';

registerLocaleData(localeNl, 'nl');

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

// temporary workaround for integration with XC
// in the CMS the script tags are added to the head of the document
// this causes the bootstrap code to execute too early
// https://stackoverflow.com/questions/35644123/the-selector-my-app-did-not-match-any-elements
// the permanent fix will be made in XC, until then this is the workaround
document.addEventListener('DOMContentLoaded', () => {
    platformBrowser()
        .bootstrapModule(RetailSamenRekeningOpenenModule)
        // eslint-disable-next-line no-console
        .catch((err) => console.log(err)); // NOSONAR
});
